import React, {useEffect, useState} from "react";
import s from './styles.module.css'
import {observer} from "mobx-react-lite";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {Checkbox, CircularProgress, FormControl, MenuItem, Select} from "@mui/material";
import classNames from "classnames";
import {dynamicFormulaStore} from "../../../store/store";

const DynamicFormulaRow = observer(({
                                        index,
                                        formula,
                                        ageGroupSelect,
                                        deleteSumFormula,
                                        renameSumFormula,
                                        deleteFormulaId,
                                    }) => {

    const [openModal, setOpenModal] = useState(false);
    const [formulaName, setFormulaName] = useState(formula.formula_name);
    const [deletingId, setDeletingId] = useState(null);
    const hasComponents = formula.discipline_results?.length > 0;

    useEffect(() => {
        const getDisciplineForSumFormula = async () => {
            await dynamicFormulaStore.getDisciplineForSumFormula();
        }
        getDisciplineForSumFormula().then(() => {
        });
    }, []);

    const deleteDisciplineFormula = (disciplineResultId) => {
        const performDelete = async () => {
            await dynamicFormulaStore.deleteDisciplineFormula(disciplineResultId);
        };

        setDeletingId(disciplineResultId); // Устанавливаем ID удаляемого элемента
        performDelete()
            .then(() => {
                setDeletingId(null); // Сбрасываем после успеха
            })
            .catch((error) => {
                setDeletingId(null); // Сбрасываем при ошибке
                console.error("Ошибка при удалении компонента формулы: ", error);
            });
    };

    const addDisciplineFormula = (ageGroupId, disciplineId, formulaId) => {
        const performAdd = async () => {
            await dynamicFormulaStore.addDisciplineFormula(ageGroupId, disciplineId, formulaId);
        }

        performAdd().then(() => {
        }).catch((error) => {
            console.error("Ошибка при добавлении компонента формулы: ", error);
        });
    }

    return (
        <div style={{marginBottom: '40px'}}>
            <div>{index !== 0 && <hr style={{marginBottom: '20px', border: '1px solid #ddd'}}/>}</div>
            <Dialog
                sx={{
                    maxWidth: '100% !important',
                }}
                open={openModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Удалить {formula.formula_name}?
                </DialogTitle>

                <DialogActions>
                    <Button fullWidth variant="contained" color="primary"
                            onClick={() => {
                                deleteSumFormula(formula.formula_id);
                                setOpenModal(false);
                            }}>Удалить</Button>
                    <Button fullWidth variant="contained" color="error"
                            onClick={() => setOpenModal(false)}>Отмена</Button>
                </DialogActions>
            </Dialog>

            <div className={s.row}>
                <div className={s.row_top}>
                    <div> {index === 0 && <p className={s.title_row}></p>}</div>
                    <FormControl fullWidth sx={{
                        maxWidth: '100%',
                        height: '32px'
                    }}>
                        <Select
                            placeholder={'Дисциплины'}
                            displayEmpty
                            value={null}
                            onChange={(e) => {
                                addDisciplineFormula(ageGroupSelect, e.target.value, formula.formula_id)
                            }}
                            inputProps={{'aria-label': 'Without label'}}
                            sx={{
                                height: '32px',
                                backgroundColor: '#fff'
                            }}
                            labelId="demo-simple-select-label"
                        >

                            <MenuItem sx={{
                                display: 'none'
                            }} hidden disabled selected value={null}>Дисциплины</MenuItem>
                            {dynamicFormulaStore.disciplinesForSumFormula.map((item) => (
                                <MenuItem key={item.discipline_id} value={item.discipline_id}>
                                    {item.discipline_name}
                                </MenuItem>))}
                        </Select>
                    </FormControl>
                </div>
                <div className={s.row_bottom}>
                    <div className={s.formula_name_row}>
                        <div className={s.checkbox_col}>
                            {hasComponents && (
                                <Checkbox
                                    className={s.is_use_checkbox}
                                    color="info"
                                    checked={!!formula.is_use}
                                    onChange={(e) => {
                                        dynamicFormulaStore.updateIsUse(ageGroupSelect, formula.formula_id, e.target.checked)
                                    }}
                                />
                            )}
                        </div>
                        <div className={s.name_box}>
                            <div className={s.action} onClick={() => setOpenModal(true)}>
                                {deleteFormulaId === formula.formula_id ? (
                                    <CircularProgress size="12px" color="inherit"/>
                                ) : (
                                    <div>X</div>
                                )}</div>
                            <input className={s.input} type="text" value={formulaName || ''}
                                   onChange={(e) => setFormulaName(e.target.value)}/>
                            <div className={s.action}
                                 onClick={() => {
                                     renameSumFormula(formula.formula_id, formulaName);
                                 }}>S
                            </div>
                        </div>
                    </div>
                    <div className={s.chosing_items}>
                        {formula.discipline_results.map((item, index) => (
                            <div
                                className={classNames(
                                    s.chosing_items_item,
                                    formula.discipline_results.length === index + 1 ? '' : s.chosing_items_item_plus
                                )}
                                key={item.discipline_result_id}
                            >
                                <div className={s.chosing_items_item_title}>{item.discipline_result_name}</div>
                                <div
                                    className={s.action}
                                    onClick={() => deleteDisciplineFormula(item.discipline_result_id)}
                                >
                                    {deletingId === item.discipline_result_id ? (
                                        <CircularProgress size="12px" color="inherit"/>
                                    ) : (
                                        <div>X</div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default DynamicFormulaRow;
